module.exports = __webpack_public_path__ + "static/first_frame_video_preview-ac72f3940238a9b4bfae7a02a2f2c9f8.png";